import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-monitor-mac',
  templateUrl: './monitor-mac.component.html',
  styleUrls: ['./monitor-mac.component.css']
})
export class MonitorMacComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
